/**
 * en-GB messages added by Phase 4 task TR1 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const tr1EnGB = {};
//# sourceMappingURL=tr1.js.map